import React, { useEffect, useState } from "react";
import { getDays, getMonthNumber, getMonths, getYears } from "../utils/Statics";
import ErrorText from "./ErrorText";
import { isValid, parse } from "date-fns";

type DateSelectorType = {
  day: string;
  month: string;
  year: string;
  disabled?: boolean;
  required?: boolean;
  onDaySelect: (value: string) => void;
  onMonthSelect: (value: string) => void;
  onYearSelect: (value: string) => void;
  min18Years?: boolean;
};

const DateSelector = ({
  day,
  month,
  year,
  disabled,
  required,
  onDaySelect,
  onMonthSelect,
  onYearSelect,
  min18Years,
}: DateSelectorType) => {
  const [dateNotValid, setDateNotValid] = useState(false);

  useEffect(() => {
    if (day && month && year) {
      const dateString = `${year}-${getMonthNumber(month)}-${day}`;
      const parsedDate = parse(dateString, "yyyy-MM-dd", new Date());
      setDateNotValid(!isValid(parsedDate));
    }
  }, [day, month, year]);

  function getPlaceholder(text: string) {
    return required ? `${text} *` : text;
  }

  return (
    <>
      <PlainSelect
        placeholder={getPlaceholder("Day")}
        value={day}
        list={getDays()}
        disabled={disabled}
        onSelect={(e) => onDaySelect(e.target.value)}
      />
      <PlainSelect
        placeholder={getPlaceholder("Month")}
        value={month}
        list={getMonths()}
        disabled={disabled}
        onSelect={(e) => onMonthSelect(e.target.value)}
      />
      <PlainSelect
        placeholder={getPlaceholder("Year")}
        value={year}
        list={getYears(min18Years)}
        disabled={disabled}
        onSelect={(e) => onYearSelect(e.target.value)}
      />
      {dateNotValid && <ErrorText>The entered date is not valid!</ErrorText>}
    </>
  );
};

const PlainSelect = ({
  value,
  placeholder,
  list,
  disabled,
  onSelect,
}: {
  value: string;
  placeholder: string;
  list: string[];
  disabled?: boolean;
  onSelect: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}) => {
  return (
    <select
      className="select select-bordered min-w-full mb-4 rounded-none"
      onChange={onSelect}
      disabled={disabled}
    >
      <option value="" disabled selected={value === ""}>
        {placeholder}
      </option>

      {list.map((item) => (
        <option key={item} selected={item === value}>
          {item}
        </option>
      ))}
    </select>
  );
};

export default DateSelector;
